module.exports = __webpack_public_path__ + "img/shopping_cart_gray.3f4d74fc.svg";